import { useEffect, useState } from "react";
import { Box, IconButton, Modal, Stack, TextField, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import {
  SAVE_COMPANIES,
  SAVE_PRODUCTS,
  SAVE_SITES,
  SAVE_USER_SITES_PROJECTS
} from "../../constant/Apipath";
import { English } from "../../constant/EnglishFallback";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";

const AddWebsiteModal = ({ open, onClose, from, data, onDataSave, onSaveClick }) => {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const currentUserId = loginData?.userInformation?.UserId ?? 0;

  const [website, setWebsite] = useState("");
  const [isValid, setIsValid] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);

  const {
    BUTTON_ADD_WEBSITE = English?.AddWebsiteModal?.BUTTON_ADD_WEBSITE,
    TEXT_INPUT_LABEL_WEBSITE = English?.AddWebsiteModal?.TEXT_INPUT_LABEL_WEBSITE,
    TEXT_ENTER_VALID_URL = English?.AddWebsiteModal?.TEXT_ENTER_VALID_URL,
    TEXT_INVALID_URL = English?.AddWebsiteModal?.TEXT_INVALID_URL
  } = multiLanguageData?.AddWebsiteModal || {};

  const urlRegex = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;

  const handleWebsiteChange = (e) => {
    const value = e.target.value.trim();
    setWebsite(value);
    // Check that the input is either empty or matches full domain with TLD
    if (value === "" || urlRegex.test(value)) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  };

  const getSaveObj = () => {
    let saveObject = {
      userId: Number(currentUserId),
      ReturnRecordId: true,
      ReturnRecordError: true,
      SaveList: []
    };

    const baseFields = {
      Id: data?.id,
      Name: data?.name,
      webSite: website,
      Active: data?.active || data?.Active,
      phone: data?.phone,
      ModifiedBy: Number(currentUserId),
      RecordStatusId: 1
    };

    if (from === "company" || from === "manufacture") {
      return {
        ...saveObject,
        SaveList: [{ ...baseFields, Manufacturer: from === "manufacture" }]
      };
    }

    if (from === "product") {
      return {
        ...saveObject,
        SaveList: [
          {
            ...baseFields,
            Info: data?.info,
            productType: data?.productType,
            ManufacturerId: data?.manufacturerId
          }
        ]
      };
    }

    if (from === "project") {
      return {
        ...saveObject,
        SaveList: [
          {
            Id: data?.id,
            UserId: Number(currentUserId),
            SiteId: data?.siteId,
            projectName: data.projectName,
            ProjectType: data?.projectType,
            ProjectWebsite: website,
            Description: data?.description,
            IsActive: data?.isActive,
            ModifiedBy: Number(currentUserId),
            RecordStatusId: 1
          }
        ]
      };
    }
    if (from === "SiteCard") {
      return {
        ...saveObject,
        SaveList: [
          {
            Id: data?.id || 0,
            Name: data?.name,
            Address: data?.address,
            City: data?.city,
            Province: data?.province,
            PostalCode: data?.postalCode,
            Country: data?.country,
            Latitude: data?.latitude,
            Longitude: data?.longitude,
            Active: true,
            RecordStatusId: 1,
            ModifiedBy: Number(currentUserId),
            WebSite: website
          }
        ]
      };
    }
  };

  const getApiUrl = () => {
    if (from === "company" || from === "manufacture") return SAVE_COMPANIES;
    if (from === "product") return SAVE_PRODUCTS;
    if (from === "project") return SAVE_USER_SITES_PROJECTS;
    if (from === "SiteCard") return SAVE_SITES;
    return "";
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (website.trim() === "" || !urlRegex.test(website)) {
      setIsValid(false);
      return; // 🔒 Block API call
    }
    if (onSaveClick !== undefined || onSaveClick !== null) {
      onSaveClick();
    }

    try {
      setSubmitLoading(true);
      const obj = getSaveObj();
      await Postrequestcall(getApiUrl(), obj, loginData?.accessToken);
      onClose();
      onDataSave();
    } catch (error) {
      console.log("onSubmit-> Error When Adding Website: ", error);
      onClose();
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <Modal open={open}>
      <Box className="user-modal-responsive">
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Typography variant="h6" ml={1}>
            {BUTTON_ADD_WEBSITE}
          </Typography>
          <Stack flexDirection={"row"}>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
            <IconButton
              loading={submitLoading}
              color="primary"
              disabled={website.trim() === "" || !isValid} // Disable if invalid
              onClick={onSubmit}>
              <SaveIcon />
            </IconButton>
          </Stack>
        </Box>
        <Box p={1}>
          <TextField
            autoFocus
            variant="outlined"
            label={TEXT_INPUT_LABEL_WEBSITE}
            placeholder={TEXT_ENTER_VALID_URL+ " eg. www.xyz.com"}
            fullWidth
            value={website}
            onChange={handleWebsiteChange}
            error={!isValid}
            helperText={!isValid ? TEXT_INVALID_URL : ""}
            onKeyPress={(event) => {
              if (event.key === "Enter") onSubmit(event);
            }}
          />
        </Box>
      </Box>
    </Modal>
  );
};

export default AddWebsiteModal;
